

















import { inject } from "inversify-props";
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import { DoctorModel } from "@/models/doctor";
import { auth, doctor as store } from "@/store/modules";
import { IDoctorService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({})
class DoctorSelector extends Vue {
  @inject(DependencyIdentifiers.DoctorService)
  private doctorService!: IDoctorService;

  @Prop() doctorId?: string;
  private disabled = auth.isPatient;

  private async refresh() {
    this.isLoading = true;
    try {
      let size = 100,
        page = 1,
        total = 0;
      do {
        const [items, {}] = await this.doctorService.getMany(page, size);
        this.items = [...items];
        this.items = items.sort((a, b) => (a.name > b.name ? 1 : -1));
      } while (page * size < total);
    } finally {
      this.isLoading = false;
    }
  }

  async mounted() {
    await this.refresh();
    if (this.doctorId) {
      this.value = this.doctorId.toString();
    }
  }

  private isLoading = true;
  private items: Array<DoctorModel> = [];
  private value: string | null = null;

  @Emit("change")
  onChange(value: string | null) {
    return value;
  }
}

export default DoctorSelector;
